// extracted by mini-css-extract-plugin
export default {"addNewTenantContainer":"AddTenant_addNewTenantContainer__8eRX3"};